import { CHARACTER_VARIANTS } from './../../Characters/scripts/constants'
import * as THREE from 'three'
import { Material, Mesh, MeshMatcapMaterial, MeshStandardMaterial, Object3D } from 'three'
import { useSceneStore } from '../../../a.scenes/GameScene/store'

// FIRE
const matcapTexture = new THREE.TextureLoader().load(
  'https://makio135.com/matcaps/64/660505_F2B090_DD4D37_AA1914-64px.png',
)

// const matcapTexture = new THREE.TextureLoader().load('https://makio135.com/matcaps/64/E6BF3C_5A4719_977726_FCFC82-64px.png')

export const restoreFromRedMatCapMaterials = (obj: Object3D) => {
  const materialsCache = useSceneStore.getState().getMaterials()
  const originalName = 'White'
  const matKey = `${originalName}_${CHARACTER_VARIANTS.DIABLO}`
  obj.traverse((o: Object3D | Mesh) => {
    if (o.type === 'Mesh') {
      const mesh = o as Mesh
      const mat = mesh.material as MeshStandardMaterial
      if (mat.name === matKey) {
        mesh.material = materialsCache.get(originalName) as Material
      }
    }
  })
}
const replaceRedMatCapMaterial = (obj: Object3D) => {
  const materialsCache = useSceneStore.getState().getMaterials()
  const addMaterial = useSceneStore.getState().addMaterial
  obj.traverse((o: Object3D | Mesh) => {
    if (o.type === 'Mesh') {
      const mesh = o as Mesh
      const mat = mesh.material as MeshStandardMaterial
      if (mat.name === 'White') {
        // save current material in cache
        if (!materialsCache.has(mat.name)) {
          addMaterial(mat.name, mat)
        }

        const newMatKey = `${mat.name}_${CHARACTER_VARIANTS.DIABLO}`
        if (!materialsCache.has(newMatKey)) {
          const newMat = new THREE.MeshMatcapMaterial({
            matcap: matcapTexture,
            normalMapType: THREE.TangentSpaceNormalMap,
            side: THREE.DoubleSide,
            name: newMatKey,
          })
          addMaterial(newMatKey, newMat)
        }

        mesh.material = materialsCache.get(newMatKey) as Material
      }
    }
  })
}
export default replaceRedMatCapMaterial
